export default __webpack_public_path__ + "static/07436ad0f4c94a0a246a296923cf57d9.png";